import React from "react";

export const languages = {
  en: {
    spanish: "Spanish",
  },
  es: {
    spanish: "Español",
    orders360: "Pedidos 360",
    legacy: "Vendedores",
    massive: "Envios Rechazados",
    budgets: "Descarga Presupuestos",
    ordersTab: "Pedidos",
    rejectedTab: "Envíos rechazados",
    budgetsTab: "Presupuestos",
    jan: "Ene",
    feb: "Feb",
    mar: "Mar",
    apr: "Abr",
    may: "May",
    jun: "Jun",
    jul: "Jul",
    aug: "Ago",
    sep: "Sep",
    oct: "Oct",
    nov: "Nov",
    dev: "Dic",
    day: "Día",
    summary: "Resumen",
    ranking: "Ranking",
    PDVWithoutVisit: "pdv s/visita",
    timeFirstCheckIn: "Hora primer checkin",
    timeLastCheckOut: "Hora ultimo checkout",
    subregion: "Subregion",
    leader: "Jefe",
    supervisor: "Supervisor",
    seller: "Vendedor",
    sellerType: "Tipo de vendedor",
    qtySelectedItems: (qty: number) => `${qty} seleccionados`,
    pdvsInRoute: "PDVs en ruta",
    pdvsVisited: "PDVs c/visita en ruta",
    pdvsRouteWithSell: "PDVs c/pedido en ruta",
    visitId: "ID visita",
    calendarDate: "Fecha calendario",
    timeCheckIn: "Hora checkin",
    timeCheckOut: "Hora checkout",
    visitStatus: "Status Visita",
    visitDuration: "Duración Visita",
    clientId: "Cliente id",
    clientName: "Razon social dsc",
    clientFantasyName: "Nombre fantasia",
    address: "Direccion",
    hasSellFlag: "Flag tiene venta",
    pdvWithValidVisit: "PDV c/visita valida",
    qtyClientsWithoutVisit: "Cant. clientes s/visita",
    region: "Region",
    distributor: "Distribuidor",
    organization: "Sucursal",
    filter: "Filtrar",
    resetFilters: "Limpiar filtros",
    surveyProgressSummary: "Resumen avance",
    respondentsVisitsHistory: "Maestro de visitas",
    campaign: "Campaña",
    distributorExternCode: "Código consolidado",
    distributorName: "Nombre Distribuidor",
    target: "Target",
    progress: "Avance",
    periodStart: "Comienzo periodo",
    periodEnd: "Fin periodo",
    percentTotalAnswersModifiedOnline: "% de respuestas modificadas online",
    percentRespondentsModifiedOnline:
      "% pdv con al menos una respuesta modificada online",
    organizationExternCode: "Código sucursal",
    respondentCode: "Código pdv",
    employeeCode: "Código empleado",
    isInUniverse: "Está en universo",
    visitDate: "Fecha visita",
    validVisit: "Visita válida",
    dateFrom: "Fecha desde",
    dateTo: "Fecha hasta",
    onlyValidVisit: "Solo vistas válidas",
    onlyUniverse: "Solo universo",
    valid: (gen = "F") => `valid${gen === "F" ? "a" : "o"}`,
    invalid: (gen = "F") => `invalid${gen === "F" ? "a" : "o"}`,
    true: "Si",
    false: "No",
    regionProgress: "Avance region",
    answersVsTarget: "Respuestas vs target",
    distributorRanking: "Ranking distribuidor",
    totalRespondents: "Total censado",
    answers: "Respuestas",
    atWorkingHours: "En horas laborales",
    period: "Período",
    surveyCampaignsTargetTags: "Campañas target",
    surveyCampaignsAnswersTags: "Campañas censadas",
    month: "Mes",
    year: "Año",
    insightId: "ID Alerta",
    description: "Descripción",
    detail: "Detalle",
    details: "Detalles",
    insights: "Alertas",
    category: "Categoría",
    insightNoRecordMessage: "No existen alertas para los días seleccionados.",
    services: "Servicios",
    hasGPS: "Usa GPS",
    hasMasuno: "Usa Masuno",
    coordsOrigin: "Origen de coordenadas",
    createVolume: "Crear Volumen",
    createCoverages: "Crear Coberturas",
    createFocus: "Crear Focos",
    missions: "Misiones",
    create: "Crear",
    reactivate: "Re Activar",
    pause: "Pausar",
    delete: "Eliminar",
    byType: "Por Tipo",
    newFocus: "Nuevo Foco",
    start: "Inicio",
    end: "Fin",
    date: "Fecha",
    objective: "Objetivo",
    totalObjective: "Objetivo Total",
    partialObjective: "Objetivo Parcial",
    all: "Todos",
    focus: "Foco",
    startDate: "Fecha Inicio",
    expirationDate: "Fecha Vto.",
    endDate: "Fecha Fin",
    focusType: "Tipo de Foco",
    focusAssignedTo: "Foco asignado a",
    assignedTo: "Asignado a",
    inProgress: "En curso",
    futures: "Futuros",
    past: "Pasados",
    state: "Estado",
    type: "Tipo",
    businessUnit: "Unidad de Negocio",
    division: "División",
    family: "Familia",
    brand: "Marca",
    caliber: "Calibre",
    flavor: "Sabor",
    cancel: "Cancelar",
    confirm: "Confirmar",
    back: "Volver",
    next: "Siguiente",
    focusName: "Nombre del Foco",
    focusStatus: "Estado",
    descriptionOrComments: "Descripción/Comentarios",
    notSelectedGroupProductFocusItemsMessage: "Completá todos los campos. En caso que alguno no aplique, seleccioná la opción “No aplica”",
    invalidGroupProductFocusMessage: "No se encontraron productos para los criterios elegidos",
    repeatedGroupProductFocusMessage: "El grupo está repetido",
    notAssignedFocusSellersMessage: "Para crear un foco necesitás tener vendedores asignados. Revisá la estructura cargada en la web de Axum y en D+",
    notAssignedFocusSellersTargetMessage: "Completá la asignación a todos los vendedores. En caso que no formen parte del Foco, asignales 0 como objetivo",
    selectFocusValidityMessage: "Seleccioná la vigencia del foco",
    focusGroupCount: (group: number) => `Componente #${group} del Foco`,
    addGroupToFocus: "Sumar otro componente más al foco",
    noFocusesCreated: "Aún no creaste ningún foco",
    noCurrentFocuses: "No hay focos en curso",
    noPastFocuses: "No hay focos pasados",
    noFutureFocuses: "No hay focos futuros",
    confirmDeleteFocusMessage: "¿Estás seguro que querés eliminar este foco?",
    confirmDeleteFocusesMessage: "¿Estás seguro que querés eliminar estos focos?",
    fieldRequired: "Campo requerido",
    invalidStartEndDateRange: "La fecha de fin debe ser posterior a la fecha de inicio",
  },
};

export const languageContext = React.createContext(
  { languageContext: languages.es } // default value
);
